import { Badge } from '@/components/ui/badge'

export type AccountingSyncState = 'Pending' | 'Synced' | 'Error'

export function AccountingSyncBadge({
  state,
  detail,
}: {
  state: AccountingSyncState | null
  detail?: string | null
}) {
  if (!state) return null

  const variant = state === 'Synced' ? 'success' : state === 'Error' ? 'destructive' : 'warning'
  return (
    <Badge variant={variant} title={detail ?? undefined}>
      {state}
    </Badge>
  )
}
